// extracted by mini-css-extract-plugin
export default {"hoursTable":"BusinessHours_hoursTable__gCqAl","day":"BusinessHours_day__4ZLkv","separator":"BusinessHours_separator__3Gd-A","closed":"BusinessHours_closed__j4x4l"};